import { Link } from 'react-router-dom';

export default function HeroSection() {
  return (
    <section className="relative w-full min-h-screen flex items-center overflow-hidden">
      <div className="absolute inset-0 z-0">
        <img
          src="https://readdy.ai/api/search-image?query=Artistic%20abstract%20collage%20of%20fashion%20items%20including%20sneakers%20handbags%20watches%20and%20scarves%20floating%20organically%20against%20warm%20terracotta%20gradient%20background%2C%20creative%20editorial%20composition%2C%20soft%20dreamy%20lighting%2C%20elevated%20brand%20aesthetic%2C%20no%20text%20overlay%2C%20modern%20minimal%20collage%20style&width=1920&height=1080&seq=v2-hero-bg&orientation=landscape"
          alt="Mulebuy Spreadsheet product categories background"
          className="w-full h-full object-cover object-top"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-black/30 via-black/20 to-black/35"></div>
      </div>

      <div className="relative z-10 w-full px-6 md:px-10 py-32 md:py-40">
        <div className="flex flex-col lg:flex-row items-start lg:items-center gap-12 lg:gap-20">
          <div className="w-full lg:w-7/12">
            <p className="text-accent-300 text-sm md:text-base font-label tracking-widest uppercase mb-4">
              Complete Resource Hub
            </p>
            <h1 className="font-heading text-4xl md:text-5xl lg:text-6xl xl:text-7xl font-bold text-background-50 leading-tight mb-6">
              Mulebuy Spreadsheet Database
              <span className="block text-accent-300 text-2xl md:text-3xl lg:text-4xl mt-3 font-normal">
                The Most Complete Mulebuy Spreadsheet Resource Online
              </span>
            </h1>
            <p className="text-background-200/80 text-base md:text-lg max-w-xl leading-relaxed mb-8">
              Discover, compare, and explore the most updated <strong>Mulebuy Spreadsheet</strong> lists, guides, and product sourcing data. Your one-stop destination for organized product databases and sourcing insights.
            </p>
            <div className="flex flex-col sm:flex-row gap-4">
              <a
                href="https://kaspreadsheet.com/"
                target="_blank"
                rel="noopener nofollow"
                className="px-8 py-3.5 rounded-full bg-primary-500 text-background-50 text-sm md:text-base font-semibold hover:bg-primary-600 transition-all whitespace-nowrap cursor-pointer text-center"
              >
                Mulebuy Spreadsheet
              </a>
              <Link
                to="/what-is-mulebuy-spreadsheet"
                className="px-8 py-3.5 rounded-full border-2 border-background-50 text-background-50 text-sm md:text-base font-semibold hover:bg-background-50 hover:text-foreground-950 transition-all whitespace-nowrap cursor-pointer text-center"
              >
                Explore Mulebuy Spreadsheet Guide
              </Link>
            </div>
          </div>

          <div className="w-full lg:w-5/12 hidden lg:block">
            <div className="relative">
              <div className="w-full aspect-[4/5] rounded-2xl overflow-hidden">
                <img
                  src="https://readdy.ai/api/search-image?query=Stylish%20fashion%20flat%20lay%20with%20designer%20sneakers%20leather%20wallet%20and%20premium%20watch%20arranged%20on%20textured%20concrete%20surface%2C%20overhead%20shot%2C%20soft%20directional%20lighting%2C%20luxury%20editorial%20quality%2C%20warm%20earthy%20tones%2C%20modern%20minimal%20composition&width=800&height=1000&seq=v2-hero-side&orientation=portrait"
                  alt="Premium product showcase for Mulebuy Spreadsheet"
                  className="w-full h-full object-cover"
                />
              </div>
              <div className="absolute -bottom-4 -right-4 bg-primary-500 text-background-50 rounded-2xl px-6 py-4 shadow-lg">
                <p className="text-3xl font-heading font-bold">14+</p>
                <p className="text-xs opacity-80">Categories</p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}